// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"59997a9d","729":"0636f908","770":"b3768d7b","918":"0cd178bb"}[chunkId] + ".chunk.js";
};